import {
    Component, Prop, Mixins, Vue,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';
import { configs } from '@nodes/configs';

// import FontAwesomeIcon
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

// import MaterialIcons
import '@material-design-icons/font';

// Register FontAwesomeIcon
library.add(fab);
library.add(fas);
library.add(far);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

/**
 * Icon Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Tag name used to render icon's element
     */
    @Prop({ type: String, default: 'i' }) tag!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: configs.project.fontIcon || 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string

    /**
     * Change map color when use in another component.
     */
    @Prop({ type: Boolean }) inner!: boolean;
}

export default Props;
